<template>
  <header>
    <div class="headerCont">
      <a class="logoCont" :href="urlPath.index">
        <div class="logo">
          <!-- <img src="./../assets/comm/logo_hppc.png" alt="和平電力" /> -->
          <img :src="'./img/logo_hppc.png'" alt="和平電力" />
        </div>        
        <h1>和平電力</h1>
      </a>
      <!-- <nav>
        <a :href="setUrl(urlPath.about)">關於和電</a>
        <a :href="setUrl(urlPath.renewable)">再生能源</a>
        <a :href="setUrl(urlPath.powerReport)">公司治理</a>
        <a :href="setUrl(urlPath.social)">社會共好</a>
        <a :href="setUrl(urlPath.envReport)">環境管理</a>
        <a :href="setUrl(urlPath.join)">加入和電</a>
      </nav> -->
      <nav class="navPC" ref="navPC">
        <!-- <div class="topicMenuGroup">
          <a class="tit" :href="setUrl(urlPath.getp)">會員專區</a>
          <a class="tit" :href="setUrl(urlPath.platform)">綠電交易平台</a>
        </div>
        <div class="clear"></div> -->
        <ul class="menuGroup">
          <!-- <li><div class="tit"><a href="./match.html">媒合專區</a></div></li> -->
          <!-- <li><div class="tit"><a href="./factoryInfo.html">電廠資訊</a></div></li> -->
          <!-- <li>
            <div class="tit">　Q &amp; A　</div>
            <div class="subMenu">
              <div class="subTit">
                <a href="">問題11111111111111111111</a>
              </div>
              <div class="subTit">
                <a href="">問題2</a>
              </div>
            </div>            
          </li> -->
          <li v-for="(row, idx) in menu" :key="idx">
            <template v-if="row.subTitStage1.length==0">
              <!-- <div class="tit"><a :href="row.url">{{row.tit}}</a></div> -->
              <div class="tit"><a :href="setUrl(row.pathName)">{{row.tit}}</a></div>
            </template>
            <template v-else>
              <div class="tit titGap">{{row.tit}}</div>
              <div class="subMenu">
                <div class="subTit" v-for="(row2, idx) in row.subTitStage1" :key="idx">
                  <a v-if="row2.type=='outerLink'" target="_blank" :href="row2.pathName">{{row2.subTit}}</a>
                  <a v-else :href="setUrl(row2.pathName)">{{row2.subTit}}</a>
                </div>
              </div>
            </template>
          </li>
        </ul>
        <div class="clear"></div>
      </nav>
      <div class="navPcEndBorder" ref="navPcEndBorder"></div>

      <nav class="navPhone">
        <div class="hamburger" ref="hamburger" togglePhoneMenuGroupStatus="false" @click="togglePhoneMenuGroup">
          <transition name="hamburOpenClose">
            <i class="hamburOpen fa-solid fa-bars"  v-show="isPhoneMenuShow"></i>
          </transition>
          <!-- <transition name="hamburOpenClose">
            <i class="hamburClose fas fa-times" v-show="!isPhoneMenuShow"></i>
          </transition> -->
        </div>
        <transition name="navPhoneBackShowHidden">
          <div class="navPhoneBack" ref="navPhoneBack" v-show="isNavPhoneBackShow"></div>
        </transition>
        <div class="menuGroup" ref="menuGroup">
          <div class="hamburgerX" @click="togglePhoneMenuGroup">
            <i class="hamburClose fa-solid fa-xmark"></i>
          </div>
          <!-- <div class="menu">
            <a class="tit" href="">媒合專區</a>
          </div>
          <div class="menu">
            <a class="tit" href="">電廠資訊</a>
          </div>
          <div class="menu">
            <div class="tit" togglePhoneSubMenuStatus="false" idx="2" @click="togglePhoneSubMenu">關於我們</div>
            <div class="subMenu">
              <div class="subTit">
                <a href="">問題11111111111111111111</a>
              </div>
              <div class="subTit">
                <a href="">問題2</a>
              </div>
            </div>
          </div> -->

          <div class="menu" v-for="(row, idx) in menu" :key="idx">
            <template v-if="row.subTitStage1.length==0">
              <a class="tit" :href="setUrl(row.pathName)">{{row.tit}} <i class="fas fa-arrow-down arrow"></i></a>
            </template>
            <template v-else>
              <div class="tit" togglePhoneSubMenuStatus="false" :idx="idx" @click="togglePhoneSubMenu">{{row.tit}} <i class="fas fa-arrow-down arrow"></i></div>
              <div class="subMenu">
                <div class="subTit" v-for="(row2, idx) in row.subTitStage1" :key="idx">
                  <a v-if="row2.type=='outerLink'" target="_blank" :href="row2.pathName">{{row2.subTit}}</a>
                  <a v-else :href="setUrl(row2.pathName)">{{row2.subTit}}</a>
                </div>
              </div>
            </template>
          </div>

          <!-- <div class="menu">
            <div class="tit" togglePhoneSubMenuStatus="false" :idx="menu.length" @click="togglePhoneSubMenu">Extend Menu Test</div>
            <div class="subMenu">
              <div class="subTit">
                <a href="">Q111</a>
              </div>
              <div class="subTit" v-for="(row, idx) in 20" :key="idx">
                <a href="">Q222</a>
              </div>
            </div>
          </div> -->
        </div>
      </nav>

    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { UrlPath, Util } from '../util/util';
// import $ from 'jquery'

export default defineComponent({
  name: 'CommHeader',
  // props: {
  //   msg: String,
  // },
  data: function() {
    return {
      urlPath: UrlPath,
      isPhoneMenuShow: true,
      isNavPhoneBackShow: false,
      menu: [
        {
          tit:"和電故事",
          subTitStage1: [
            {subTit: "關於和平電力", pathName: UrlPath.aboutHPPC},
            {subTit: "穩定供電責任", pathName: UrlPath.aboutStablePower},
            {subTit: "電力人才萌芽", pathName: UrlPath.aboutPowerTalent}
          ]
        },
        {
          tit:"能源轉型",          
          subTitStage1: [
            {subTit: "我們的責任", pathName: UrlPath.energyTransitionResponsibility},
            {subTit: "投入再生能源", pathName: UrlPath.energyTransitionRenewable},
            {subTit: "減碳的努力", pathName: UrlPath.energyTransitionReduceCarbon}
          ]
        },
        {
          tit:"海洋溫差發電",
          pathName: UrlPath.otec,
          subTitStage1: []
        },
        {
          tit:"環境管理",          
          subTitStage1: [
            {subTit: "資源循環管理", pathName: UrlPath.environmentCircular},
            {subTit: "水資源管理", pathName: UrlPath.environmentWater},
            {subTit: "空氣排放管理", pathName: UrlPath.environmentAir},
            {subTit: "海域監測", pathName: UrlPath.environmentOcean},
            {subTit: "環境品質監測報告書", pathName: UrlPath.environmentReport},
            {subTit: "附近海域生態調查報告", pathName: UrlPath.environmentSeaReport, type:"outerLink"}
            // {subTit: "附近海域生態調查報告", pathName: "https://media.taiwancement.com/web_tcc/tw/report/tcfd/report_2023_all.pdf", type:"outerLink"}
          ]
        },
        {
          tit:"職業安全衛生",
          pathName: UrlPath.safetyHealth,
          subTitStage1: []
        },
        {
          tit:"公正轉型",
          subTitStage1: [
            {subTit: "公正轉型", pathName: UrlPath.justTransition},
            {subTit: "台泥碳學院", pathName: UrlPath.justTransitionCarbonCollege},
          ]
        },
        {
          tit:"社會共好",
          subTitStage1: [
            {subTit: "環境教育推廣", pathName: UrlPath.socialEducation},
            {subTit: "小燕鷗保育", pathName: UrlPath.socialConservation},
            {subTit: "在地部落共好", pathName: UrlPath.socialTribe},
            {subTit: "海事急難救助金", pathName: UrlPath.socialRelief},
          ]
        },
        {
          tit:"加入和電",
          subTitStage1: [
            {subTit: "企業文化與福利", pathName: UrlPath.joinBenefit},
            {subTit: "青年實習培育", pathName: UrlPath.joinPractice},
          ]
        },
        {
          tit:"最新消息",
          pathName: UrlPath.newsList,
          subTitStage1: []
        }
        // {
        //   tit:"常見Q & A",
        //   subTitStage1: [
        //     {subTit: "買賣電 123 123 123", pathName: ""},
        //     {subTit: "五類問題", pathName: ""}
        //   ]
        // },
        // {
        //   tit:"測試測試測試",
        //   subTitStage1: [
        //     {subTit: "ABCDEFG", pathName: "UrlPath.newsList"},
        //     {subTit: "123 123 123", pathName: "UrlPath.QA"},
        //     {subTit: "456 456 456 456 456 456", pathName: "/getp/#/membership/buyer/1/"}            
        //   ]
        // }
      ]
    }
  },
  methods: {
    setUrl: function(pathName: string) {
      return Util.setUrl(pathName);
    },
    togglePhoneMenuGroup(e: any) {
      this.isPhoneMenuShow = !this.isPhoneMenuShow;
      this.isNavPhoneBackShow = !this.isNavPhoneBackShow;
      let status: string|null = (this.$refs.hamburger as HTMLElement).getAttribute("togglePhoneMenuGroupStatus");
      // let navPhoneShortcutHeight: number = parseInt((document.querySelectorAll(".navPhoneShortcut .shortcut")[0] as HTMLElement).style.height);
      // let headerH = this.$refs.header.clientHeight;      

      if(status == "false") {
        (this.$refs.menuGroup as HTMLElement).style.width = document.documentElement.clientWidth - 60 + "px"; // 60 is Hamburger Width
        (this.$refs.menuGroup as HTMLElement).style.height = document.documentElement.clientHeight + "px";
        // (this.$refs.menuGroup as HTMLElement).style.paddingBottom = navPhoneShortcutHeight + 5 + "px";
        (this.$refs.menuGroup as HTMLElement).style.paddingBottom = 5 + "px";
        (this.$refs.menuGroup as HTMLElement).style.display = "block";
        (this.$refs.menuGroup as HTMLElement).style.overflowY = "auto";
        (this.$refs.hamburger as HTMLElement).setAttribute("togglePhoneMenuGroupStatus", "true");
        $(".navPhone .menuGroup").animate( {
            left: "0",
          },
          500,
          function() {
            (document.querySelector("body") as HTMLElement).style.overflowY = "hidden";
          }
        );
        // (this.$refs.menuGroup as HTMLElement).style.left = "0";
        (document.querySelector("body") as HTMLElement).style.overflowY = "hidden";
      } else {
        (this.$refs.hamburger as HTMLElement).setAttribute("togglePhoneMenuGroupStatus", "false");
        $(".navPhone .menuGroup").animate( {
            left: -1 * (document.documentElement.clientWidth - 60) + "px", // 60 is Hamburger Width,
          },
          500,
          function(this: HTMLElement) {
            $(this).css("display", "none");
            (document.querySelector("body") as HTMLElement).style.overflowY = "auto";
          }
        );
        // (this.$refs.menuGroup as HTMLElement).style.left = -1 * (document.documentElement.clientWidth - 60) + "px"; // 60 is Hamburger Width
        (document.querySelector("body") as HTMLElement).style.overflowY = "auto";
      }
    },
    togglePhoneSubMenu(e: any) {
      let status = e.currentTarget.getAttribute("togglePhoneSubMenuStatus");
      let idx = e.currentTarget.getAttribute("idx");      
      let subMenu = e.currentTarget.nextSibling;

      console.log(subMenu.children.length);
      console.log(subMenu.children[0].offsetHeight);

      if(subMenu.children.length > 0) {
        if(status == "false") {
          let subTitHeight = subMenu.children[0].offsetHeight;
          // subMenu.style.height = subTitHeight * subMenu.children.length + "px";
          $(".navPhone .menu:eq(" + idx + ") .subMenu").animate({height: subTitHeight * subMenu.children.length + "px"}, 200);
          e.currentTarget.setAttribute("togglePhoneSubMenuStatus", "true");
        } else {
          // subMenu.style.height = "0px";
          $(".navPhone .menu:eq(" + idx + ") .subMenu").animate({height: "0px"}, 200);
          e.currentTarget.setAttribute("togglePhoneSubMenuStatus", "false");
        }
      }
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
header {
  background: #fff;
}

header .headerCont {
  width: 1200px;
  margin: auto;
  display: flex;
  /* justify-content: space-between; */
  position: relative;  
}

header .headerCont .logoCont {
  flex: 0 1 50px;
  padding: 10px 0;
  display: inline-flex;
  align-items: center;
  color: #0B1E6B;
}

header .headerCont .logoCont .logo {
  flex: 0 0 40px;
}

header .headerCont .logoCont .logo img {
  width: 100%;
  vertical-align: bottom;
}

header .headerCont .logoCont h1 {
  margin: 0 0 0 10px;
  letter-spacing: 3px;
  line-height: 1em;
  display: none;
}


/* header .headerCont nav {
  flex: 0 0 auto;
}

header .headerCont nav a {
  margin: 15px;
  padding: 5px;
  box-sizing: border-box;
  display: inline-block;
  border-bottom: solid 2px transparent;
  color: #303030;
}

header .headerCont nav a:hover {
  border-bottom: solid 2px #0088ff;
} */


header .headerCont .navPC {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  text-align: center;
  /* opacity: 0;   */
}

header .headerCont .navPC .topicMenuGroup {
  display: flex;
  justify-content: flex-end;
}

header .headerCont .navPC .topicMenuGroup .tit {
  padding: 15px 20px;
  letter-spacing: 2px;
  color: #5eac85;
}

header .headerCont .navPC .menuGroup {
  margin: 0;
  padding: 0;
  list-style: none;
}

header .headerCont .navPC .menuGroup > li {
  float: left;
  position: relative;
}

header .headerCont .navPC .menuGroup > li > .tit {
  box-sizing: border-box;
  display: inline-block;
  /* border: solid 1px #5eac85; */
  /* border-left: none; */
  /* border-bottom: none; */
  letter-spacing: 2px;
  font-weight: 500;
  font-size: 15px;
  color: #505050;
  transition: color 0.5s;
}

header .headerCont .navPC .menuGroup > li:hover > .tit {
  color: #0A5F99;
}

header .headerCont .navPC .menuGroup > li > .tit.titGap {
  padding: 20px 25px;
  box-sizing: border-box;
}

header .headerCont .navPC .menuGroup > li > .tit.titActive {
  background: #f8c51a;
}

header .headerCont .navPC .menuGroup > li:last-child > .tit {
  border-right: none;
}

header .headerCont .navPC .menuGroup > li > .tit a {
  padding: 20px;
  box-sizing: border-box;
  display: inline-block;
  color: #505050;
}

header .headerCont .navPC .menuGroup > li > .tit a:hover {
  color: #0A5F99;
}

header .headerCont .navPC .menuGroup > li > .subMenu {
  margin: -15px auto 0;
  padding: 0;
  display: none;
  list-style: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 5px #00000022;
}

header .headerCont .navPC .menuGroup > li:hover > .subMenu {
  display: block;
  border-top: solid 3px #00a8f3;
  word-break: keep-all;
}

/* header .headerCont .nav .menuGroup > li > .subMenu > li > a { */
header .headerCont .navPC .menuGroup > li > .subMenu > .subTit > a {
  width: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  display: block;
  /* border: solid 1px #5eac85; */
  white-space: nowrap;
  letter-spacing: 2px;
  font-weight: 500;
  /* color: #5eac85; */
  color: #474747;
  background: #fff;
  transition: color 0.5s;
}

header .headerCont .navPC .menuGroup > li > .subMenu > .subTit > a:hover {  
  color: #0A5F99;
  /* background: #5eac85; */
  /* background: #ccf1ff; */
}

header .headerCont .navPcEndBorder {
  width: 100%;
  position: absolute;
  bottom: 0;
  border-bottom: solid 1px #5eac85;
  opacity: 0;
}



header .headerCont .navPhoneBack {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
  background: rgba(0, 0, 0, 0.75);
  transform: translateZ(0);
}

header .headerCont .navPhoneBackShowHidden-enter-active,
header .headerCont .navPhoneBackShowHidden-leave-active {
  transition: left 0s, opacity 1s;
}

header .headerCont .navPhoneBackShowHidden-enter,
header .headerCont .navPhoneBackShowHidden-leave-to {
  left: -100%;
  opacity: 0;
}

header .headerCont .navPhoneBackShowHidden-enter-to,
header .headerCont .navPhoneBackShowHidden-leave {
  left: 0;
  opacity: 1;
}

header .headerCont .navPhone {
  width: 100%;
  display: none;
  margin: -1px 0 0;
  position: absolute;
  left: 0;
  top: 0;
  vertical-align: bottom;
}

header .headerCont .navPhone .hamburger {
  width: 50px;
  height: 50px;
  position: absolute;
  right: 0;
  /* top: -60px; */  
  cursor: pointer;
  /* background: #ccc; */
  /* color: #f8c51a; */
  color: #3077A8;
}

header .headerCont .navPhone .hamburger .hamburOpen {
  position: absolute;
  left: 10px;
  top: 12px;
  font-size: 28px;
}

header .headerCont .navPhone .hamburger .hamburClose {
  position: absolute;
  left: 17px;
  top: 15px;
  font-size: 32px;
}

header .headerCont .navPhone .hamburOpenClose-enter-active, 
header .headerCont .navPhone .hamburOpenClose-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}

header .headerCont .navPhone .hamburOpenClose-enter,
header .headerCont .navPhone .hamburOpenClose-leave-to {
  opacity: 0;
  /* transform: rotate(-180deg); */
}

header .headerCont .navPhone .hamburOpenClose-enter-to, 
header .headerCont .navPhone .hamburOpenClose-leave {
  opacity: 1;
  /* transform: rotate(0deg); */
}

header .headerCont .navPhone .menuGroup {
  width: 80%;
  height: 100%;
  padding: 0 5px;
  box-sizing: border-box;
  overflow-y: auto;
  position: absolute;
  left: -80%;
  top: 0;
  z-index: 2;
  /* background: #f8c51a; */
  /* background: #c0ffff; */
  background: #f8f8f8;
  /* background: rgba(0, 0, 0, 0.5); */
  transform: translateZ(0);
}

header .headerCont .navPhone .menuGroup .hamburgerX .hamburClose {
  margin: 15px 0 20px 40px;
  font-size: 40px;
  /* color: #5eac85; */
  color: #3077A8;
}

header .headerCont .navPhone .menuGroup .menu {
  cursor: pointer;
}

header .headerCont .navPhone .menuGroup .menu .tit {
  width: 100%;;
  padding: 20px 40px;
  box-sizing: border-box;
  display: block;
  letter-spacing: 1px;
  font-weight: 400;
  color: #303030;
}

header .headerCont .navPhone .menuGroup .menu .tit .arrow {
  margin: 5px 0 0;
  /* color: #5eac85; */
  color: #3077A8;
  float: right;
  font-size: 20px;
}

header .headerCont .navPhone .menuGroup .menu .subMenu {
  height: 0;
  vertical-align: bottom;
  overflow: hidden;
  /* background: #202020; */
  background: #e8e8e8;
}

header .headerCont .navPhone .menuGroup .menu .subMenu .subTit a {
  padding: 20px 0;
  box-sizing: border-box;
  display: block;
  text-align: center;
  /* color: #5eac85; */
  color: #3077A8;
}

@media screen and (min-width: 1px) and (max-width: 1200px) {
  header .headerCont {
    width: 100%;
  }

  header .headerCont .dummyFillHeight {
    height: 60px;
  }

  header .headerCont .logoCont {
    padding: 6px 10px;
    flex: 1 1 70%;
  }

  header .headerCont .logoCont .logo {
    flex: 0 0 38px;
    left: 10px;
    bottom: 10px;
  }

  header .headerCont .logoCont .logo img {
    width: 100%;
  }

  header .headerCont .logoCont h1 {
    /* padding: 8px 20px 10px 10px; */
    font-size: 24px;
  }

  header .headerCont .navPC {
    display: none;
  }

  header .headerCont .navPhone {
    display: block;
  }

  header .navPhoneShortcut {
    display: flex;
  }
}
</style>